import { Option } from "~/types/component";
import { Question, Answer } from "~/types/question";
import { MasterState } from "~/redux/modules/master";

// 質問文
export const questionTextFormat = (val: Question["questionText"]) => {
  let formatValue = "";
  val.forEach((question, index) => {
    if (question.text !== "") {
      formatValue += `${question.text}`;
      if (index < val.length - 1) {
        formatValue += "\n";
      }
    }
  });
  return formatValue;
};

// 複数回答
export const multipleFormat = (val: Question["multiple"]) => {
  if (val === true) {
    return "可";
  } else {
    return "不可";
  }
};

// 新規の質問かどうか
export const isNextQuestionFormat = (val: Question["isNextQuestion"]) => {
  if (val === true) {
    return "次の質問";
  } else {
    return "新規の質問";
  }
};

// 回答方式
export const answerTypeFormat = (val: Question["textAnswer"]) => {
  if (val === true) {
    return "テキスト入力";
  } else {
    return "選択式";
  }
};

// ノートカテゴリ
export const categoriesFormat = (
  val: Question["categoryId"],
  master: MasterState
) => {
  const { categories } = master;
  return findLabel(val, categories);
};

// 回答
export const answerFormat = (
  key: keyof Answer,
  val: Question["answerOptions"]
) => {
  let formatValue = "";
  val.forEach((answer, index) => {
    if (answer[key] !== "") {
      formatValue += `${index + 1}: ${answer[key]}`;
      if (index < val.length - 1) {
        formatValue += "\n";
      }
    }
  });
  return formatValue;
};

// optionsから特定のlabelを取得
const findLabel = (val: string | number, options: Option[]) => {
  const result = options.find((item) => item.value === val);
  if (result) {
    return result.label;
  } else {
    return "";
  }
};
